module.exports = __webpack_public_path__ + "img/skull_17.7d2da045.png";